import React, { lazy, Suspense} from "react";

import DefaultLoader from "../utilities/loaders/DefaultLoader";
const AccessRequestContent = lazy(() => import('./AccessRequestsContent'));



const AccessRequestApproval = () => {
    return (
        <Suspense fallback={<DefaultLoader />}>
            <AccessRequestContent />
        </Suspense>
    );
};

export default AccessRequestApproval;